import React from 'react';
import { Container, Typography, Box, useTheme } from '@mui/material';
import { ContentUseCase } from '../../corelogic/usecases/ContentUseCase';
import { useLanguage } from '../../shared/contexts/LanguageContext';
import { SEO } from './SEO';

const contentUseCase = new ContentUseCase();

export const CookiePage: React.FC = () => {
  const theme = useTheme();
  const { language } = useLanguage();
  const { cookies } = contentUseCase.getLegalContent(language);

  return (
    <Container maxWidth="md" sx={{ py: theme.spacing(8) }}>
      <SEO page="cookies" />
      <Typography variant="h2" component="h1" gutterBottom align="center" color="primary" sx={{ mb: theme.spacing(6) }}>
        {cookies.title}
      </Typography>
        {/* What are Cookies */}
        <Box sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {cookies.what.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {cookies.what.description}
          </Typography>
        </Box>

        {/* Which Cookies */}
        <Box sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {cookies.which.title}
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {cookies.which.necessary.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {cookies.which.necessary.description}
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {cookies.which.preferences.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {cookies.which.preferences.description}
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {cookies.which.analytics.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {cookies.which.analytics.description}
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {cookies.which.tracking.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {cookies.which.tracking.description}
          </Typography>
        </Box>

        {/* Decline */}
        <Box sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {cookies.decline.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {cookies.decline.description}
          </Typography>
          <ul>
            {cookies.decline.effects.map((effect, idx) => (
              <li key={idx}>
                <Typography variant="body1" color="text.primary">{effect}</Typography>
              </li>
            ))}
          </ul>
        </Box>

        {/* Manage */}
        <Box sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {cookies.manage.title}
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {cookies.manage.settings.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {cookies.manage.settings.description}
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {cookies.manage.browser.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {cookies.manage.browser.description}
          </Typography>
        </Box>

        {/* Contact */}
        <Box sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {cookies.contact.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {cookies.contact.description}
          </Typography>
          <Typography variant="body1" color="text.primary">
            {cookies.contact.email}
          </Typography>
        </Box>
    </Container>
  );
};

